<script setup>
import { computed } from 'vue';
import { formatPlainDateByRegion } from '../../helpers';

const props = defineProps({
    post: {
        type: Object,
        required: true
    }
});

const itemLink = computed(() => {
    if (props.post.postTags.data.some((item) => item.name === 'BreakingNews')) {
        return { path: '/hkcmnews/breaking-news', query: { id: props.post.id } };
    } else {
        return `/hkcmnews/${props.post?.slug?.name}`;
    }
});
</script>

<template>
    <router-link :to="itemLink"
        class="flex items-center p-2 rounded-lg border transition-all ease-in-out gap-2 border-gray-200">
        <div class="flex-grow">
            <div class="flex flex-row items-center gap-2">
                <div class="w-4 h-4 bg-blue rounded-full border border-blue-light shadow-lg"></div>
                <p class="text-sm text-gray-600">{{ formatPlainDateByRegion(post.published_at) }}</p>
            </div>
            <p class="font-semibold text-sm">{{ $translate(post.title) }}</p>
        </div>
    </router-link>
</template>
